import styles from "./CourseQuiz.module.css";
import { useState } from 'react';

function CourseQuiz({ quiz }) {
    const [answers, setAnswers] = useState({});
    const [revealed, setRevealed] = useState({});

    const handleCheck = (index) => {
        if (answers[index] !== undefined) {
            setRevealed(prev => ({ ...prev, [index]: true }));
        }
    };

    const handleReset = (index) => {
        setAnswers(prev => ({ ...prev, [index]: undefined }));
        setRevealed(prev => ({ ...prev, [index]: false }));
    };

    return (
        <div className={styles.quiz}>
            {quiz.map((question, index) => (
                <div key={index} className={styles.quizQuestion}>
                    <div className={styles.quizHeader}>
                        <span className={styles.quizBadge}>Question {index + 1} of {quiz.length}</span>
                    </div>
                    <p className={styles.quizQuestion}>{question.question}</p>
                    <ul className={styles.quizOptions}>
                        {question.options.map((opt, i) => {
                            let optClass = styles.quizOption;
                            if (revealed[index]) {
                                if (i === question.answer) optClass += ` ${styles.optCorrect}`;
                                else if (i === answers[index]) optClass += ` ${styles.optWrong}`;
                            } else if (i === answers[index]) {
                                optClass += ` ${styles.optSelected}`;
                            }
                            return (
                                <li key={i}>
                                    <button
                                        className={optClass}
                                        onClick={() => !revealed[index] && setAnswers(prev => ({ ...prev, [index]: i }))}
                                        disabled={revealed[index]}
                                    >
                                        <span className={styles.optIndex}>{String.fromCharCode(65 + i)}</span>
                                        {opt}
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                    <div className={styles.quizActions}>
                        {!revealed[index] ? (
                            <button
                                className={styles.quizSubmit}
                                onClick={() => handleCheck(index)}
                                disabled={answers[index] === undefined}
                            >
                                Check answer
                            </button>
                        ) : (
                            <>
                                <p className={answers[index] === question.answer ? styles.resultCorrect : styles.resultWrong}>
                                    {answers[index] === question.answer ? '✓ Correct! Well done.' : '✗ Not quite: the correct answer is highlighted above.'}
                                </p>
                                <button className={styles.quizReset} onClick={() => handleReset(index)}>Try again</button>
                            </>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default CourseQuiz;